import { render, staticRenderFns } from "./ViewKeyPointModal.vue?vue&type=template&id=4a0624ee&scoped=true"
import script from "./ViewKeyPointModal.vue?vue&type=script&lang=js"
export * from "./ViewKeyPointModal.vue?vue&type=script&lang=js"
import style0 from "./ViewKeyPointModal.vue?vue&type=style&index=0&id=4a0624ee&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0624ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a0624ee')) {
      api.createRecord('4a0624ee', component.options)
    } else {
      api.reload('4a0624ee', component.options)
    }
    module.hot.accept("./ViewKeyPointModal.vue?vue&type=template&id=4a0624ee&scoped=true", function () {
      api.rerender('4a0624ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/statistic/components/ViewKeyPointModal.vue"
export default component.exports